import { ImportConfigurationRepository } from '../data/import-configuration-repository';
import { SheetMappingDetailResponse } from '../types/import-configuration-types';

/**
 * Use case for getting a single sheet mapping with its column mappings
 */
export class GetSheetMappingDetailUseCase {
  constructor(private readonly repository: ImportConfigurationRepository) {}

  async execute(mappingId: number): Promise<SheetMappingDetailResponse> {
    return this.repository.getSheetMappingById(mappingId);
  }
}
